import React from 'react';
import { Link } from 'react-router-dom';

interface BannerHeaderProps {
   title: string;
   backTo?: string;
}

export function BannerHeader({ title, backTo }: BannerHeaderProps) {
   const base = process.env.PUBLIC_URL || '';

   return (
      <header className="swamp-banner">
         <img
            className="swamp-banner__image"
            src={`${base}/images/swamp/page/banner-header.png`}
            alt=""
         />
         <div className="swamp-banner__content">
            {backTo && (
               <Link to={backTo} className="swamp-banner__back" aria-label="Go back">
                  ←
               </Link>
            )}
            <h1 className="swamp-banner__title">{title}</h1>
         </div>
      </header>
   );
}
